<template>
  <div class="switch">
    <input id="switch-1" type="checkbox" class="switch-input" v-model="selectedValue" @change="changeSubscription(selectedValue)"/>
    <label for="switch-1" class="switch-label">Switch</label>
  </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {

    data(){
        return{
            selectedValue:false
        }
    },
    methods:{
        ...mapActions([
            'changeSubscription'
        ]),
    }
}
</script>

<style>

</style>